export const articleCategories = [
  { slug: 'news', label: '新闻资讯', icon: 'ri-newspaper-line', color: 'primary' },
  { slug: 'live', label: '赛事直播', icon: 'ri-live-line', color: 'accent' },
  { slug: 'schedule', label: '赛程赛果', icon: 'ri-calendar-check-line', color: 'secondary' },
  { slug: 'teams', label: '球队介绍', icon: 'ri-shield-line', color: 'primary' },
  { slug: 'reviews', label: '平台评测', icon: 'ri-star-line', color: 'accent' },
  { slug: 'guide', label: '观赛指南', icon: 'ri-guide-line', color: 'secondary' },
];

export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryLabel: string;
  date: string;
  imageUrl: string;
  author: string;
  tags: string[];
}

export const allArticles: Article[] = [
  {
    id: 'news-1',
    title: '2026世界杯赛程正式公布：48支球队角逐美加墨',
    summary: '国际足联正式公布了2026年世界杯完整赛程，48支参赛球队将在美国、加拿大和墨西哥的16座城市展开为期39天的激烈角逐。揭幕战将于6月11日在墨西哥城具有传奇色彩的阿兹特克体育场拉开帷幕。',
    content: `<p>国际足联（FIFA）于近日正式公布了2026年美加墨世界杯的完整赛程安排。作为世界杯历史上首次由三个国家联合主办的赛事，本届世界杯将在美国、加拿大和墨西哥的16座顶级体育场馆中，迎来48支参赛球队的激烈角逐。</p>

<h3>揭幕战：墨西哥城点燃战火</h3>
<p>2026年6月11日（星期四），本届世界杯的揭幕战将在墨西哥城阿兹特克体育场打响。这座承载着1970年和1986年两届世界杯决赛记忆的传奇球场，将第三次成为世界杯历史的重要见证者。作为东道主之一的墨西哥队，预计将在这座八万七千余座位的球场中迎来小组赛首战。</p>

<h3>小组赛：16组48队全新赛制</h3>
<p>2026年世界杯首次扩军至48支参赛球队，小组赛将采用16个小组、每组3支球队的全新赛制。每个小组的前两名将晋级32强淘汰赛阶段。这一赛制改革使得更多国家和地区有机会站上世界杯的舞台，同时也让小组赛阶段的每一场比赛都充满悬念——任何一场失利都可能意味着出局。</p>
<p>小组赛阶段将从6月11日持续至6月27日，共计48场比赛。比赛将分布在16座主办城市的场馆中密集进行，为全球球迷奉献一场足球盛宴。</p>

<h3>淘汰赛：从32强到终极对决</h3>
<p>淘汰赛阶段将从6月28日的32强赛开始，经历16强、8强、半决赛，最终于7月19日（星期日）在纽约/新泽西大都会人寿体育场迎来万众瞩目的决赛。此外，7月18日将在洛杉矶索菲体育场举行季军争夺战。</p>
<p>整个淘汰赛阶段的赛程设计充分考虑了球队休息时间和转场距离，确保各支球队能够在最佳状态下进行比赛。</p>

<h3>主办城市与场馆分布</h3>
<p>美国11座城市承担了绝大多数比赛场次，包括决赛举办地纽约/新泽西、季军赛举办地洛杉矶，以及达拉斯、亚特兰大、迈阿密等体育重镇。加拿大方面，多伦多和温哥华将分别承办小组赛和淘汰赛。墨西哥的墨西哥城、瓜达拉哈拉和蒙特雷三座城市也将承担重要比赛任务。</p>

<h3>转播与观赛</h3>
<p>全球超过200个国家和地区将获得2026世界杯的转播权，预计全球累计观众将超过50亿人次。在中国，多个主流平台已确认获得转播授权，球迷可以通过高清直播欣赏全部104场比赛。</p>`,
    category: 'news',
    categoryLabel: '新闻资讯',
    date: '2026-07-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20photography%20of%20packed%20football%20stadium%20at%20sunset%20with%20golden%20hour%20lighting%2C%20green%20pitch%2C%20dramatic%20sky%2C%20wide%20angle%20shot%2C%20atmospheric%20mood%2C%20warm%20tones%2C%20editorial%20quality&width=1200&height=600&seq=article-news-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['赛程', '2026世界杯', '美加墨', 'FIFA'],
  },
  {
    id: 'news-2',
    title: '2026世界杯抽签仪式确定：12月在迈阿密举行',
    summary: '国际足联确认2026年世界杯小组赛抽签仪式将于2025年12月在迈阿密举行，届时48支晋级球队的分组命运将一一揭晓，全球球迷翘首以盼的死亡之组是否会诞生？',
    content: `<p>国际足联官方宣布，2026年世界杯小组赛抽签仪式将于2025年12月在美丽的迈阿密举行。这座佛罗里达的阳光之城将成为48支参赛球队命运交汇的关键节点。</p>
<h3>抽签仪式亮点</h3>
<p>作为世界杯历史上规模最大的一届赛事，本次抽签仪式将邀请多位足坛传奇人物作为抽签嘉宾。国际足联主席因凡蒂诺将亲自主持仪式，届时全球数亿球迷将通过直播见证这一重要时刻。</p>
<h3>分档规则</h3>
<p>48支球队将根据国际足联最新世界排名分为四个档次。三个东道主——美国、加拿大和墨西哥——自动获得第一档种子队资格，确保各自所在小组的主场优势。其余球队将根据排名和地理分布原则进行分档和抽签。</p>`,
    category: 'news',
    categoryLabel: '新闻资讯',
    date: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20event%20venue%20with%20football%20themed%20stage%20design%2C%20gold%20and%20green%20color%20scheme%2C%20spotlights%2C%20championship%20trophy%20display%2C%20luxurious%20atmosphere%2C%20professional%20event%20photography&width=1200&height=600&seq=article-news-2-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['抽签', '迈阿密', '小组赛', 'FIFA'],
  },
  {
    id: 'news-3',
    title: '东道主美国队公布世界杯备战计划：剑指四强',
    summary: '美国国家队主教练公布了详细的2026世界杯备战计划，包括多场高质量热身赛安排和球员选拔方案。作为东道主之一，美国队志在主场创造历史最佳战绩。',
    content: `<p>作为2026年世界杯的东道主之一，美国国家队近日公布了详尽的备战计划。主教练在新闻发布会上表示，球队的目标是在本土世界杯上至少闯入四强，创造美国足球新的历史。</p>
<h3>备战日程</h3>
<p>美国队的备战计划分为三个阶段：首先是阵容考察期，教练组将密切追踪效力于欧洲五大联赛的美国球员状态；其次是集训磨合期，计划安排4至6场高质量热身赛，对手包括南美和欧洲的顶级球队；最后是赛前冲刺期，球队将提前进入比赛城市进行适应性训练。</p>
<h3>核心阵容</h3>
<p>目前美国队拥有一批在欧洲豪门效力的年轻才俊，包括在英超、德甲和意甲担任主力的多名球员。这支平均年龄不到26岁的年轻阵容，兼具速度、体能和技术，被视为2026世界杯最有潜力的黑马之一。</p>`,
    category: 'news',
    categoryLabel: '新闻资讯',
    date: '2026-06-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=American%20football%20soccer%20team%20training%20session%20on%20pristine%20green%20pitch%2C%20athletes%20in%20white%20and%20navy%20kit%2C%20dynamic%20action%20shot%2C%20bright%20sunlight%2C%20professional%20sports%20photography%2C%20clean%20stadium%20background&width=1200&height=600&seq=article-news-3-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['美国队', '东道主', '备战', '阵容'],
  },
  {
    id: 'news-4',
    title: '世界杯球场巡礼：16座顶级场馆准备就绪',
    summary: '从纽约大都会人寿体育场到洛杉矶索菲体育场，2026世界杯16座比赛场馆的升级改造工程已进入最后冲刺阶段，每座场馆都配备了最新的科技设施和观赛体验系统。',
    content: `<p>距离2026世界杯开幕还有不到一年的时间，16座比赛场馆的升级改造工程已进入最后冲刺阶段。从东海岸到西海岸，从加拿大到墨西哥，每一座球场都在为迎接全球球迷做着最后的准备。</p>
<h3>决赛场地：大都会人寿体育场</h3>
<p>位于新泽西州东卢瑟福的大都会人寿体育场将承办2026世界杯决赛。这座可容纳82,500名观众的顶级体育场是NFL纽约巨人队和纽约喷气机队的主场，经过世界杯专项升级后，其草皮系统、照明设施和观众服务系统均达到了国际足联的最高标准。</p>
<h3>科技升级</h3>
<p>所有16座场馆均配备了5G全覆盖网络、高清LED环形屏幕、以及全新的VAR视频助理裁判系统接口。部分场馆还安装了可伸缩屋顶和智能温控系统，确保在任何天气条件下都能为球员和观众提供最佳的比赛和观赛环境。</p>`,
    category: 'news',
    categoryLabel: '新闻资讯',
    date: '2026-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ultra%20modern%20football%20stadium%20aerial%20view%20at%20golden%20sunset%2C%20architectural%20masterpiece%20with%20retractable%20roof%2C%20surrounded%20by%20city%20skyline%2C%20dramatic%20lighting%2C%20professional%20architectural%20photography%2C%20warm%20atmospheric%20tones&width=1200&height=600&seq=article-news-4-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['场馆', '球场巡礼', '基础设施'],
  },
  {
    id: 'news-5',
    title: '2026世界杯门票销售即将开启：购票攻略全解析',
    summary: '2026年世界杯门票销售阶段和时间安排已公布，本文为您详细解读各阶段售票规则、票价区间、以及如何提高抢票成功率的实用技巧，助您现场感受世界杯的魅力。',
    content: `<p>随着2026世界杯的脚步日益临近，门票销售成为广大球迷最为关注的话题之一。国际足联已公布门票销售的整体时间安排和规则框架，以下为您带来详细的购票攻略。</p>
<h3>销售阶段</h3>
<p>世界杯门票销售将分为三个阶段：第一阶段为抽签申请期，球迷需在规定时间内提交购票申请，国际足联将随机抽签分配门票；第二阶段为先到先得期，未售罄的场次将面向公众开放即时购买；第三阶段为最后时刻销售期，将在比赛临近时释放少量余票。</p>
<h3>票价区间</h3>
<p>小组赛门票起步价约为105美元，淘汰赛逐步递增，决赛门票最高可达1,100美元。国际足联还为东道国居民预留了优惠票价，部分场次的最低票价可低至69美元。</p>`,
    category: 'guide',
    categoryLabel: '观赛指南',
    date: '2026-06-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20FIFA%20World%20Cup%20match%20tickets%20and%20passport%20on%20wooden%20table%2C%20golden%20trophy%20in%20background%20with%20bokeh%20effect%2C%20warm%20lighting%2C%20aspirational%20travel%20aesthetic%2C%20premium%20product%20photography&width=1200&height=600&seq=article-news-5-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['门票', '购票攻略', '观赛指南'],
  },
  {
    id: 'news-6',
    title: '世界杯新规解读：2026年将采用多项创新规则',
    summary: '国际足联宣布2026世界杯将试行多项创新比赛规则，包括扩大换人名额、引入更精准的半自动越位技术，以及首次在世界杯使用足球视频助理裁判系统的升级版本。',
    content: `<p>国际足联（FIFA）正式宣布，2026年世界杯将引入并试行多项创新比赛规则和技术升级。这些变化旨在提升比赛公平性、加快比赛节奏，并为全球球迷带来更好的观赛体验。</p>
<h3>半自动越位技术升级</h3>
<p>继2022年卡塔尔世界杯首次引入半自动越位技术后，2026世界杯将使用该技术的升级版本。新版系统在比赛用球中嵌入了更精密的惯性测量单元（IMU），能够以每秒500次的频率采集位置数据，配合球场周围的12台追踪摄像机，可在数秒内完成越位判定，并将3D动画展示给现场和电视观众。</p>
<h3>换人名额调整</h3>
<p>考虑到48队赛制下密集的赛程安排，国际足联将每场比赛的换人名额从5人增加至6人，加时赛另增1个换人名额。这一调整有助于球队更好地管理球员体能，减少因疲劳导致的伤病。</p>`,
    category: 'news',
    categoryLabel: '新闻资讯',
    date: '2026-06-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20VAR%20video%20assistant%20referee%20technology%20room%20with%20multiple%20screens%20and%20soccer%20match%20footage%2C%20high%20tech%20environment%2C%20clean%20professional%20setting%2C%20green%20accent%20lighting%2C%20editorial%20tech%20photography&width=1200&height=600&seq=article-news-6-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['规则', 'VAR', '技术创新', 'FIFA'],
  },
  {
    id: 'live-1',
    title: '2026世界杯直播观看指南：高清流畅不卡顿',
    summary: '全网最详细的2026世界杯直播观看指南，为您解析各大平台直播特点、网络要求、以及如何获得最佳观赛体验的实用技巧，让您不错过任何一场精彩对决。',
    content: `<p>2026世界杯全部104场比赛将通过全球各大平台进行高清直播。本文将为您全面解析如何获得最佳的世界杯直播观赛体验，从平台选择到硬件配置，一应俱全。</p>
<h3>推荐直播平台</h3>
<p>我们推荐通过国际足联官方授权的直播平台观看2026世界杯。这些平台均提供了1080P甚至4K超高清画质选项，以及多角度回放、实时数据叠加和中文解说等增值服务。部分平台还支持多设备同时观看，让您可以在手机、平板和电视之间无缝切换。</p>
<h3>网络要求</h3>
<p>流畅观看高清直播建议至少10Mbps的稳定带宽，4K超高清则需要25Mbps以上。建议使用有线网络连接以获得最稳定的观赛体验，移动端观看时尽量连接WiFi网络。</p>`,
    category: 'live',
    categoryLabel: '赛事直播',
    date: '2026-06-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20setup%20with%20large%204K%20TV%20showing%20football%20match%2C%20comfortable%20sofa%2C%20ambient%20warm%20lighting%2C%20sporty%20atmosphere%2C%20cinematic%20home%20theater%20aesthetic%2C%20clean%20contemporary%20interior&width=1200&height=600&seq=article-live-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['直播', '观赛指南', '高清', '平台推荐'],
  },
  {
    id: 'schedule-1',
    title: '2026世界杯完整赛程表：从揭幕战到决赛',
    summary: '2026年美加墨世界杯最完整的赛程时间表，涵盖全部104场比赛的日期、时间、场馆和城市信息，一键收藏，随时查阅。',
    content: `<p>2026年世界杯将在6月11日至7月19日期间，在美国、加拿大和墨西哥的16座城市举行全部104场比赛。以下是最完整的赛程总览。</p>
<h3>小组赛阶段（6月11日-6月27日）</h3>
<p>48支球队分为16个小组，每组3支球队，在17天内完成48场小组赛。每个主办城市都将承办不同数量的小组赛，比赛时间覆盖当地下午和晚间时段，以方便全球各时区球迷观看。</p>
<h3>淘汰赛阶段（6月28日-7月19日）</h3>
<p>32强赛（6月28日-7月2日）：16场比赛<br/>16强赛（7月3日-7月7日）：8场比赛<br/>四分之一决赛（7月9日-7月11日）：4场比赛<br/>半决赛（7月14日-7月15日）：2场比赛<br/>季军赛（7月18日，洛杉矶）：1场比赛<br/>决赛（7月19日，纽约/新泽西）：1场比赛</p>`,
    category: 'schedule',
    categoryLabel: '赛程赛果',
    date: '2026-06-12',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20design%20of%20football%20tournament%20bracket%20schedule%20wall%20chart%2C%20gold%20and%20green%20color%20scheme%2C%20clean%20typography%2C%20stadium%20silhouettes%2C%20FIFA%20World%20Cup%20branding%20style%2C%20elegant%20sports%20graphic%20design&width=1200&height=600&seq=article-schedule-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['赛程', '完整赛程表', '时间表'],
  },
  {
    id: 'teams-1',
    title: '2026世界杯热门球队深度解析：争冠格局前瞻',
    summary: '世界杯扩军至48队，但冠军争夺依然集中在几支传统强队。本文深度解析法国、巴西、阿根廷、英格兰等夺冠热门的阵容实力与战术体系，谁将是最后的王者？',
    content: `<p>2026世界杯虽然扩军至48支球队，但争冠格局依然由几支传统豪强主导。以下为您带来夺冠热门球队的深度分析。</p>
<h3>法国队：卫冕冠军的豪华阵容</h3>
<p>作为2018年冠军和2022年亚军，法国队拥有当今足坛最深厚的人才储备。以姆巴佩为核心的新一代法国队，在速度、技术和战术执行力上都处于世界顶级水平。三条线均有世界级球星坐镇，是本届赛事的头号夺冠热门。</p>
<h3>巴西队：重返巅峰的雄心</h3>
<p>五星巴西渴望着第六座大力神杯。新一代巴西队融合了桑巴足球的天赋与现代足球的纪律性，维尼修斯、罗德里戈等新生代球星已成长为世界级攻击手。在经验丰富的主教练带领下，巴西队有望在2026年终结多年的大赛冠军荒。</p>`,
    category: 'teams',
    categoryLabel: '球队介绍',
    date: '2026-06-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20football%20team%20lineup%20photography%2C%20players%20in%20national%20team%20kits%20lined%20up%20on%20pristine%20green%20pitch%2C%20dramatic%20stadium%20lighting%2C%20epic%20sports%20atmosphere%2C%20championship%20anticipation%20mood&width=1200&height=600&seq=article-teams-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['球队分析', '夺冠热门', '阵容', '战术'],
  },
  {
    id: 'reviews-1',
    title: '2026世界杯投注平台终极评测：五大维度横向对比',
    summary: '我们耗时一个月对主流世界杯投注平台进行了五大维度的深度评测：合规安全、赔率竞争力、中文服务、提款速度和用户福利。独家数据帮你做出最佳选择。',
    content: `<p>面对众多世界杯投注平台，如何选择一个安全合规、赔率优厚且服务完善的平台，是每位球迷关心的问题。我们耗时一个月，从五大核心维度对主流平台进行了全面横向评测。</p>
<h3>评测维度一：合规安全（权重30%）</h3>
<p>平台是否持有合法运营牌照是我们评测的第一道门槛。所有推荐平台均持有英国博彩委员会（UKGC）、马耳他博彩管理局（MGA）或菲律宾博彩监管机构（PAGCOR）等国际权威机构颁发的运营牌照，确保用户资金安全和合法权益。</p>
<h3>评测维度二：赔率竞争力（权重25%）</h3>
<p>我们对比了各平台在世界杯主要投注市场（冠军、小组出线、最佳射手等）的赔率水平。数据显示，Bet365和William Hill的整体赔率最具竞争力，其中Bet365在亚洲让球盘方面优势明显。</p>`,
    category: 'reviews',
    categoryLabel: '平台评测',
    date: '2026-06-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20comparison%20chart%20and%20data%20visualization%20dashboard%20design%2C%20gold%20and%20green%20accent%20colors%2C%20professional%20business%20analytics%20aesthetic%2C%20sports%20betting%20theme%2C%20sophisticated%20corporate%20style&width=1200&height=600&seq=article-reviews-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['平台评测', '投注', '赔率对比', '安全合规'],
  },
  {
    id: 'guide-1',
    title: '2026世界杯观赛完全手册：从出行到住宿一网打尽',
    summary: '计划亲赴美加墨现场观看2026世界杯？这份观赛完全手册涵盖签证申请、机票预订、住宿推荐、场馆交通和观赛礼仪，助你轻松开启世界杯之旅。',
    content: `<p>2026世界杯横跨三个国家、16座城市，对于计划亲赴现场观赛的球迷来说，行前准备至关重要。我们整理了这份涵盖出行、住宿、交通和观赛的全方位手册。</p>
<h3>签证与入境</h3>
<p>前往美国、加拿大和墨西哥观看世界杯，需要根据您计划观赛的城市申请相应国家的签证。美国签证（B1/B2）可同时适用于加拿大和墨西哥的部分入境政策。建议至少提前半年开始准备签证材料，预留充足的办理时间。</p>
<h3>机票与住宿</h3>
<p>世界杯期间，主办城市和周边地区的住宿价格预计将大幅上涨。建议尽早预订可免费取消的住宿选项。在机票方面，灵活选择出发和到达城市（如先飞往非主办城市再转乘国内航班）通常能节省可观的费用。</p>`,
    category: 'guide',
    categoryLabel: '观赛指南',
    date: '2026-06-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Travel%20planning%20concept%20with%20world%20map%2C%20passport%2C%20airplane%20tickets%2C%20football%20jersey%20and%20stadium%20photos%20on%20clean%20white%20desk%2C%20warm%20and%20aspirational%20lifestyle%20photography%2C%20organized%20travel%20aesthetic&width=1200&height=600&seq=article-guide-1-hero&orientation=landscape',
    author: '世界杯资讯编辑部',
    tags: ['观赛手册', '出行指南', '签证', '住宿'],
  },
];

export const aboutData = {
  brandIntro: {
    title: '关于 ZL5.net',
    subtitle: '2026世界杯官方信息聚合与服务平台',
    description: 'ZL5.net 是专注于2026年美加墨世界杯的权威信息聚合平台。我们致力于为全球华语球迷提供最及时、最全面、最权威的世界杯赛事资讯、超清直播导航、合规平台评测以及观赛指南服务。',
    mission: '让每一位球迷都能安全、便捷地享受世界杯的激情与魅力。',
    foundedIn: '2025',
    values: [
      { label: '权威可靠', desc: '与全球顶级体育数据供应商合作，确保信息准确及时' },
      { label: '安全合规', desc: '所有推荐平台均经过严格合规审查，保障用户权益' },
      { label: '用户至上', desc: '以球迷需求为导向，不断优化产品和服务体验' },
      { label: '专业深度', desc: '资深体育编辑团队，提供专业的赛事分析和深度报道' },
    ],
  },
  reputation: {
    title: '信誉展示',
    items: [
      { label: '全球覆盖', value: '200+', suffix: '个国家和地区', icon: 'ri-globe-line' },
      { label: '月度活跃', value: '500万+', suffix: '球迷用户', icon: 'ri-heart-line' },
      { label: '合作平台', value: '30+', suffix: '家认证伙伴', icon: 'ri-service-line' },
      { label: '资讯更新', value: '24/7', suffix: '全天候', icon: 'ri-time-line' },
    ],
    certifications: [
      { name: '国际体育数据协会认证', desc: '官方授权体育数据合作伙伴' },
      { name: 'SSL安全加密认证', desc: '256位SSL加密，确保用户数据安全' },
      { name: '合规运营承诺', desc: '遵守各国家和地区互联网信息服务管理规定' },
    ],
  },
  contact: {
    title: '商业合作',
    subtitle: '期待与您携手，共创世界杯商业价值',
    address: '中国深圳市南山区科技园南路88号',
    email: 'hello@cefotiam.com',
    phone: '+86 755-8888-6666',
    workHours: '周一至周五 09:00 - 18:00',
  },
};